import React from "react";
import {Spinner} from "react-bootstrap";
import FolieLayout from "./FolieLayout.jsx";
import BeispielArtikelAuswahl from "./BeispielArtikelAuswahl.jsx";
import ArtikelVerbrauchChart from "../ArtikelVerbrauchChart.jsx";
import ArtikelSaisonChart from "../ArtikelSaisonChart.jsx";
import {useGrafikHoehe} from "./FolienHoehe.js";

/** Diagramme der Folie, auf die verfügbare Fensterhöhe eingepasst (Auftrag #59). */
function WochenbedarfDiagramme({artikelDaten}) {
    const g = useGrafikHoehe();
    const verbrauch = g ? Math.max(120, g - 220) : 280;
    const saison = g ? Math.max(100, g - 300) : 220;
    return (
        <div className="row g-3">
            <div className="col-lg-8">
                <ArtikelVerbrauchChart bedarfe={artikelDaten.bedarfe} hoehe={verbrauch} />
            </div>
            <div className="col-lg-4">
                <ArtikelSaisonChart kennzahl={artikelDaten.kennzahl} artikel={artikelDaten.artikel} hoehe={saison} />
            </div>
        </div>
    );
}

export default function Folie3Wochenbedarf({beispielArtikel, onBeispielArtikelAendern, artikelDaten, ladeGerade}) {
    return (
        <FolieLayout
            nummer={4}
            titel="Wochenbedarf und Saison"
            hilfe="Aus den bereinigten Wochenwerten wird ein stabiler Basisbedarf, dazu kommt ein eigener Saisonfaktor je Monat und Farbton; zuletzt wird er auf das Lager verteilt, aus dem verkauft wird."
            breiterText
            text={
                <div className="cosmos-text-zweispaltig small">
                    <p>
                        Aus den echten Wochenwerten der letzten zwölf vollen Wochen entsteht ein robuster Basisbedarf –
                        die höchste und die niedrigste Woche zählen dabei nicht mit, damit ein einzelner Großauftrag
                        die Zahl nicht verzerrt. Zusätzlich hat jeder Farbton seinen eigenen Saisonfaktor je Monat,
                        damit Sommerfarben und Wintertöne unterschiedlich behandelt werden.
                    </p>
                    <p>
                        Eine Ausnahme gilt für zehn gepflegte Containerkunden im weiteren Ausland (Übersicht:
                        Menüpunkt „Containerkunden"): Sie bestellen sehr große Mengen auf einmal, mit einem
                        Bestellabstand, der zu stark schwankt, um echte Saisonalität abzubilden (Beispiel Australien:
                        einmal rund neun, danach nur rund drei Wochen). Ihre Bestellungen zählen deshalb bei den
                        Saisonfaktoren nicht im tatsächlichen Bestellmonat, sondern werden gleichmäßig auf alle zwölf
                        Monate verteilt – die Gesamtmenge bleibt dabei erhalten, nur die Verteilung über das Jahr
                        ändert sich. Für den Wochenbedarf, die Bestandsprojektion und die Containerkunden-Übersicht
                        selbst zählen ihre Bestellungen ganz normal mit.
                    </p>
                    <p className="mb-0">
                        Zuletzt wird der Wochenbedarf auf das Lager verteilt, aus dem der Farbton gerechnet wird. Die
                        Fakturierung sagt nicht, woher geliefert wurde – die Warenbewegungsdatei von Schneider Novus
                        zeigt aber, was ab SNV Weilheim ging (Pakete und Paletten); der Rest ging ab Lahr. Daraus
                        entsteht je Farbton ein Anteil über die letzten sechs vollen Monate, zum Beispiel gehen bei
                        PREMIUM fast alle Verkäufe ab Weilheim, bei FLAME fast alle ab Lahr. Der Bestand eines Lagers
                        sinkt in der Rechnung nur um den Teil, der auch dort verkauft wird. Das gilt nur für die vier
                        Spray-Produktlinien; für alle anderen Artikel wäre die Rechnung nicht geprüft.
                    </p>
                </div>
            }
            leseHinweis="Oben die fakturierte Menge je Woche (Balken) mit der bereinigten Linie darüber und den Shop-Bestellungen zum Vergleich. Unten die gemessenen Saisonfaktoren je Monat neben dem gepflegten Wert – 1,0 ist der Durchschnitt."
        >
            <BeispielArtikelAuswahl wert={beispielArtikel} onChange={onBeispielArtikelAendern} />
            {!artikelDaten && ladeGerade && (
                <div className="d-flex justify-content-center py-4">
                    <Spinner animation="border" size="sm" role="status">
                        <span className="visually-hidden">Wird geladen…</span>
                    </Spinner>
                </div>
            )}
            {artikelDaten && <WochenbedarfDiagramme artikelDaten={artikelDaten} />}
        </FolieLayout>
    );
}
